<template>
  <div
    v-if="$isWeb"
    :class="[svgClass]"
    aria-hidden="true"
    :style="iconStyles"
  >
    <img v-if="isColored" :src="imageIconUrl" :alt="name">
  </div>
  <view
    v-else
    :class="[svgClass]"
    aria-hidden="true"
    :style="iconStyles"
  >
    <img v-if="isColored" :src="imageIconUrl" :alt="name">
  </view>
</template>
<script>
export default {
  name: 'ImageIcon',
  props: {
    name: {
      type: String,
      required: true,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'svg'
    }
  },
  data() {
    return {
      cdnUrl:
        'https://front-end-huawei-cdn.devops.cndinfo.com/npm/@cndinfo/cube-design-icons/0.2.0'
    }
  },
  computed: {
    svgClass() {
      return 'cube-icon-image' + ` ${this.className}` || ''
    },
    imageIconUrl() {
      return this.cdnUrl + '/' + this.type + '/' + this.name + '.' + this.type
    },
    isColored() {
      return this.name.match(/-colored$/)
    },
    iconStyles() {
      return this.isColored
        ? {
          width: this.width,
          height: this.height
        }
        : {
          background: this.color,
          width: this.width,
          height: this.height,
          '-webkit-mask-box-image': 'url(' + this.imageIconUrl + ')'
        }
    }
  },
  created() {}
}
</script>

<style lang="scss" scoped>
.cube-icon-image {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  cursor: pointer;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
.font-size-100 .cube-icon-image {
  width: 0.16rem;
  height: 0.16rem;
}
</style>
